/**
 * Show scroll to top button when users scrolls at least 150px from top and go to top on button click
 */
function manageScrollBtn() {

    if ( screen.width > 767 || window.innerWidth > 767 ) {
        return;
    }

    const scrollButton = document.querySelector( '.scroll-to-top' );

    window.addEventListener( 'scroll', () => {

        if ( document.body.scrollTop > 150 || document.documentElement.scrollTop > 150 ) {
            scrollButton.style.display = "block";
        } else {
            scrollButton.style.display = "none";
        }
    })

    scrollButton.addEventListener( 'click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    })

}


window.addEventListener( 'DOMContentLoaded', () => {
    manageScrollBtn();
})